import React from 'react';

const SideContent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M15.333 1H3.111c-.58 0-1.073.488-1.257 1.167H.667c-.369 0-.667.391-.667.875v9.916C0 14.086.696 15 1.556 15h13.777c.368 0 .667-.392.667-.875V1.875c0-.483-.299-.875-.667-.875Zm-14 11.958V3.917h.445v9.041c0 .161-.1.292-.222.292-.123 0-.223-.13-.223-.292Zm13.334.292H3.095c.01-.095.016-.193.016-.292V2.75h11.556v10.5Zm-9.89-4.375h3.779c.184 0 .333-.196.333-.438v-3.5c0-.241-.15-.437-.333-.437H4.778c-.184 0-.334.196-.334.438v3.5c0 .241.15.437.334.437Zm.779-2.917h2.222v1.459H5.556V5.958Zm-1.112 5.104v-.874c0-.242.15-.438.334-.438h3.778c.184 0 .333.196.333.438v.874c0 .242-.15.438-.333.438H4.778c-.184 0-.334-.196-.334-.438Zm5.334 0v-.874c0-.242.149-.438.333-.438H13c.184 0 .333.196.333.438v.874c0 .242-.149.438-.333.438h-2.889c-.184 0-.333-.196-.333-.438Zm0-5.25v-.875c0-.241.149-.437.333-.437H13c.184 0 .333.196.333.438v.875c0 .241-.149.437-.333.437h-2.889c-.184 0-.333-.196-.333-.438Zm0 2.625v-.874c0-.242.149-.438.333-.438H13c.184 0 .333.196.333.438v.875c0 .241-.149.437-.333.437h-2.889c-.184 0-.333-.196-.333-.438Z"
    />
  </svg>
);

export default SideContent;
